// extracted by mini-css-extract-plugin
export default {"product":"hT","image_carousel":"iT","main_gallery":"jT","personalized_badge":"kT","greens_badge":"lT","arrows":"mT","slide":"nT","thumbnail_gallery":"oT","swiper-slide":"pT","learn_more":"qT","product_info":"rT","description_wrapper":"sT","checklist":"tT","checklistItem":"uT","delivery_freq":"vT","tooltip_button":"wT","key_benefits":"xT","benefit_item":"yT","ingredients":"zT","ingredient_item":"AT","active_slide":"BT","benefits_list":"CT","checkmark":"ET"};
    if(module.hot) {
      // 1715188238640
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  